<template>
<div>
  <vx-card title="Address" class="mt-3" style="min-height:250px;">
      <vs-button
        type="border"
        color="primary"
        style="font-size: 13.8px; padding: 7px; float: right; margin-top: -3.2%;"
        @click="handleedit"
      >
        Edit
      </vs-button>
      <!-- {{ localvalue }} -->
      <div class="vx-row">
        <vs-col :vs-xs="4" :vs-md="2" :vs-lg="2">
          <span>Address 1</span>
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="10" :vs-lg="10">
          {{ localvalue.address1 }}
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="2" :vs-lg="2">
          <span>Address 2</span>
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="10" :vs-lg="10">
          {{ localvalue.address2 }}
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="2" :vs-lg="2">
          <span>City</span>
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="10" :vs-lg="10">
          {{ localvalue.city }}
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="2" :vs-lg="2">
          <span>County/State</span>
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="10" :vs-lg="10">
          {{ localvalue.state }}
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="2" :vs-lg="2">
          <span>Postcode/Zip</span>
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="10" :vs-lg="10">
          {{ localvalue.zip }}
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="2" :vs-lg="2">
          <span>Country</span>
        </vs-col>
        <vs-col :vs-xs="4" :vs-md="10" :vs-lg="10">
          {{ getCountry(localvalue.platform_customer_countries_id)}}
        </vs-col>

        <!-- <vs-table :data="localvalue" class="w-full">
          <template slot="thead">
            <vs-th sort-key="add1">Address Line1</vs-th>
            <vs-th sort-key="add2">Address Line2</vs-th>
            <vs-th sort-key="city">City</vs-th>
            <vs-th sort-key="state">State</vs-th>
            <vs-th sort-key="zip">Zip</vs-th>
            <vs-th sort-key="action" style="float:right;">Action</vs-th>
          </template>

          <template>
              <vs-td :data="localvalue.address1">
                {{ localvalue.address1 }}
              </vs-td>

              <vs-td :data="localvalue.address2">
                {{ localvalue.address2 }}
              </vs-td>
              <vs-td :data="localvalue.city">
                {{ localvalue.city }}
              </vs-td>

              <vs-td :data="localvalue.state">
                {{ localvalue.state }}
              </vs-td>

              <vs-td :data="localvalue.zip">
                {{ localvalue.zip }}
              </vs-td>
              <vs-td :data="data[indextr]">
                <vs-row vs-type="flex" vs-justify="flex-end">
                  <vs-button color="primary" type="filled" icon="edit" class="mr-2" @click="handleedit(indextr)"/>
                </vs-row>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table> -->
      </div>
    </vx-card>

    <vs-popup classContent="popup-example"  title="Edit Address" :active.sync="editpopup">
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="address1" v-model="edit.address1" class="custom_Input" label="Address Line 1" icon-pack="feather" icon="icon-edit" icon-after placeholder="address line 1" style="width:100%;" vs-placeholder="Nombre" />
              <span v-show="errors.has('edit.address1')" class="text-danger">{{ errors.first('edit.address1') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-model="edit.address2" class="custom_Input" label="Address Line 2" icon-pack="feather" icon="icon-edit" icon-after placeholder="address line 2" style="width:100%;" vs-placeholder="Nombre"/>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="city" v-model="edit.city" label="City" icon-pack="feather" icon="icon-edit" icon-after placeholder="city" style="width:100%;" vs-placeholder="Nombre"/>
              <span v-show="errors.has('edit.city')" class="text-danger">{{ errors.first('edit.city') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="zip" v-model="edit.zip" class="custom_Input" label="Postcode/Zip" icon-pack="feather" icon="icon-edit" icon-after placeholder="Postcode/Zip" style="width:100%;" vs-placeholder="Nombre"/>
              <span v-show="errors.has('edit.zip')" class="text-danger">{{ errors.first('edit.zip') }}</span>
            </vs-col>
            <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="state" v-model="edit.state" class="custom_Input" label="County/State" icon-pack="feather" icon="icon-edit" icon-after placeholder="County/State" style="width:100%;" vs-placeholder="Nombre"/>
              <span v-show="errors.has('edit.state')" class="text-danger">{{ errors.first('edit.state') }}</span>
            </vs-col>
            <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
              <v-select v-model="edit.platform_customer_countries_id" v-validate="'required'" :reduce="option => option.id" label="country_name" name="Country" :options="countryList" placeholder="Country" style="width:100%;"/>
              <span v-show="errors.has('edit.Country')" class="text-danger">{{ errors.first('edit.Country') }}</span>
            </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdate">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>
</div>
</template>
<script>
import { GetCountryList } from '@/api/common'
import vSelect from 'vue-select'
export default {
  name: 'address',
  components: {
    vSelect
  },
  props: {
    value: {
      required: true,
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      addpopup: false,
      deletepopup:false,
      editpopup: false,
      // addressModalValue: {
      //   address1: '',
      //   address2: '',
      //   city: '',
      //   id: '',
      //   state: '',
      //   zip: ''
      // },
      edit:{
        address1: '',
        address2: '',
        city: '',
        id: '',
        state: '',
        zip: '',
        platform_customer_countries_id: null
      },
      editIndex: null,
      deleteindex: false,
      countryList:null
    }
  },
  mounted () {
    this.fetchCountry()
  },
  computed: {
    localvalue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    async fetchCountry () {
      try {
        const {data} = await GetCountryList()
        this.countryList = data.data.countries_list

      } catch (e) {
        //
      }
    },
    handleSave () {
      // this.$validator.validateAll('add').then(result => {
      //   if (result) {
      //     const payload = {
      //       address1: this.addressModalValue.address1,
      //       address2: this.addressModalValue.address2,
      //       city: this.addressModalValue.city,
      //       id: this.addressModalValue.id,
      //       state: this.addressModalValue.state,
      //       zip: this.addressModalValue.zip,
      //       defaults: 0
      //     }
      //     this.localvalue.push(payload)
      //     this.addpopup = false
      //     this.addressModalValue = {
      //       address1: '',
      //       address2: '',
      //       city: '',
      //       id: '',
      //       state: '',
      //       zip: '',
      //       defaults: 0
      //     }
      //   }
      // })
    },
    handleedit () {
      this.editpopup = true
      this.edit = this.localvalue
      // this.editIndex =  index
    },
    handleUpdate () {
      this.$validator.validateAll('edit').then(result => {
        if (result) {
          this.localvalue = this.edit
          this.editpopup  = false
          this.$validator.reset()
        }
      })

    },
    getCountry (id) {
      const index = this.countryList.findIndex(item => item.id === id)
      return this.countryList[index].country_name
    }
  }
}
</script>
